import React from "react";
import { SelectPetScreenWithBookingData } from "~/features/book-appointment/SelectPetScreen";

const Component = () => {
  return <SelectPetScreenWithBookingData />;
};

export default Component;
